/** Auth shell + semantic notice banner. */
import type { ReactNode } from 'react'
import { TESTID } from '../lib/testids'
import { ploteaApp } from '../lib/productProfile'
import { PloteaLegalLinks } from '../pages/PloteaLegal'

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background px-4 py-8 sm:px-8 sm:py-12">
      <div className="mx-auto flex min-h-[calc(100vh-6rem)] max-w-6xl flex-col">
        <div className="flex-1" />
        <main className="mx-auto w-full max-w-md rounded-[3px] border border-border bg-card p-6 sm:p-8">
          {children}
        </main>
        <div className="flex-1" />
        <div className="border-t border-border pt-3 font-mono text-[0.65rem] uppercase tracking-[0.12em] text-muted-foreground">
          {ploteaApp ? (
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span>Analiza działek · Plotea</span>
              <PloteaLegalLinks />
            </div>
          ) : (
            'Architecture · Visualization · Technology'
          )}
        </div>
      </div>
    </div>
  )
}

export function NoticeBanner({
  message,
  tone,
  centered = false,
}: {
  message: string
  tone: 'success' | 'error'
  centered?: boolean
}) {
  const toneClass =
    tone === 'success'
      ? 'bg-success/10 text-success'
      : 'bg-destructive/10 text-destructive'
  return (
    <div
      data-testid={
        tone === 'success' ? TESTID.noticeSuccess : TESTID.noticeError
      }
      className={`mb-4 rounded-lg p-3 text-sm ${toneClass}${centered ? ' text-center' : ''}`}
    >
      {message}
    </div>
  )
}
